import { Box } from '@mui/material';
import { CustomTextField, HorizontalForm, VerticalForm, DialogTitle } from '../../../common';

const GeneralDataSection = ({ selectedLegalEntity, onInputChange, isMobile }) => {
  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos generales
      </DialogTitle>
      {isMobile ? (
        <VerticalForm>
          <CustomTextField
            label="Razón social"
            name="legal_business_name"
            value={selectedLegalEntity.legal_business_name || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="IIBB"
            name="libb"
            value={selectedLegalEntity.libb || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="CUIT"
            name="cuit"
            value={selectedLegalEntity.cuit || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Empresa"
            name="company"
            value={selectedLegalEntity.company || ''}
            onChange={onInputChange}
            size="medium"
          />
        </VerticalForm>
      ) : (
        <HorizontalForm withBorder={false} sx={{ p: 1 }}>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
            <CustomTextField
              label="Razón social"
              name="legal_business_name"
              value={selectedLegalEntity.legal_business_name || ''}
              onChange={onInputChange}
              size="medium"
            />
            <CustomTextField
              label="IIBB"
              name="libb"
              value={selectedLegalEntity.libb || ''}
              onChange={onInputChange}
              size="medium"
            />
          </Box>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <CustomTextField
              label="CUIT"
              name="cuit"
              value={selectedLegalEntity.cuit || ''}
              onChange={onInputChange}
              size="medium"
            />
            <CustomTextField
              label="Empresa"
              name="company"
              value={selectedLegalEntity.company || ''}
              onChange={onInputChange}
              size="medium"
            />
          </Box>
        </HorizontalForm>
      )}
    </Box>
  );
};

export default GeneralDataSection;
